/**
 * Retorna los mensajes que utiliza el oomponente de errores
 * @param response
 */
export default (response) => {
  if (typeof response.response !== 'undefined') {
    if (response.response.status === 422) {
      if (typeof response.response.data.errors === 'undefined') {
        return {errors: {Error: [response.response.data.message]}}
      } else {
        return response.response.data
      }
    } else if (response.response.status === 500) {
      return {errors: {Error: [response.response.data.message]}}
    } else if (typeof response.response.data.mensaje !== 'undefined') {
      return {errors: {Error: [response.response.data.mensaje]}}
    } else if (typeof response.response.data.message !== 'undefined') {
      return {errors: {Error: [response.response.data.message]}}
    } else {
      return {errors: {Error: ['Error desconocido']}}
    }
  } else {
    return {errors: {Error: ['Error desconocido']}}
  }
}



// WEBPACK FOOTER //
// ./src/util/ManejaError.js